import React from 'react';

import { Row, Col, Button, Layout, Modal, Breadcrumb, Steps } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getVentasPorRangoFecha from '../../../graphql/querys/ventas/getVentasPorRangoFecha.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import FormRangoFechas from './FormRangoFechas';
import TablaMostrarReporte from './TablaMostrarReporte';
// import { imprimirReporte } from '../../common/funciones/imprimirReporte';

import { imprimirReporte } from '../../common/impresion/ImprimirReporteVentasPorRango';
import getVentasSQL from '../../../graphql/querys/ventas/getVentasSQL.graphql';
import generateReport from '../../../graphql/querys/ventas/generateReport.graphql';
import { descargarCSV } from '../../administracion/funciones/descargarCSV';

@graphql(getUsuario)
class ReportePorRango extends React.Component {
  state = {
    tipo_sellos: [],
    fechaInicio: '',
    fechaFin: '',
    step: 0,
  };

  onSubmit = e => {
    e.preventDefault();
    // console.log(e);
    this.buscar();
  };

  buscar = (fechaInicio, fechaFin, idOrganismo, nombreOrganismo) => {
    this.setState({
      loading: true,
      tipo_sellos: [],
      detalle_posnet: [],
      detalle_mp: [],
      ventas_efectivo: [],
      ventas_posnet: [],
      ventas_mp: [],
    });

    this.props.client
      .query({
        query: getVentasPorRangoFecha,
        variables: { fechaInicio, fechaFin, idOrganismo },
      })
      .then(res => {
        // console.log('VENTAS REPORTE: ', res.data.getVentasPorRangoFecha);

        let colVentas = res.data.getVentasPorRangoFecha;
        _.map(colVentas, venta => {
          // console.log('VENTA: ', venta);
          if (venta.datosPosnet) {
            this.actualizarTiposSellosPosnet(venta.detalle_venta.detalle);
            let ventasPosnet = this.state.ventas_posnet;
            ventasPosnet.push(venta);
            this.setState({
              ventas_posnet: ventasPosnet,
            });
          } else {
            if (venta.datosMercadoPago) {
              this.actualizarTiposSellosMercadoPago(
                venta.detalle_venta.detalle
              );
              let ventas = this.state.ventas_mp;
              ventas.push(venta);
              this.setState({
                ventas_mp: ventas,
              });
            } else {
              this.actualizarTiposSellos(venta.detalle_venta.detalle);
              let ventas = this.state.ventas_efectivo;
              ventas.push(venta);
              this.setState({
                ventas_efectivo: ventas,
              });
            }
          }
        });

        //Una vez que tenemos todos los datos, mostramos la tabla.
        this.setState({
          ...this.state,
          idOrganismo,
          nombreOrganismo,
          fechaInicio,
          fechaFin,
          step: 1,
          loading: false,
        });
      });
  };

  buscarSql = (fechaInicio, fechaFin, idOrganismo, nombreOrganismo) => {
    //La diferencia entre este metodo y el buscar, es que este le pega a la query de graphql que va a MySQL
    // Es decir, que buscan diferentes ventas, y los objetos retonardos tienen diferente formato
    this.setState({
      loading: true,
      tipo_sellos: [],
      detalle_posnet: [],
      detalle_mp: [],
      ventas_efectivo: [],
      ventas_posnet: [],
      ventas_mp: [],
    });

    this.props.client
      .query({
        query: getVentasSQL,
        variables: { fechaInicio, fechaFin, idOrganismo },
      })
      .then(res => {
        let colVentas = res.data.getVentasSQL;
        _.map(colVentas, venta => {
          if (venta.pago && venta.pago.datosPosnet) {
            this.actualizarTiposSellosPosnet(venta.detalles);
            let ventasPosnet = this.state.ventas_posnet;
            ventasPosnet.push(venta);
            this.setState({
              ventas_posnet: ventasPosnet,
            });
          } else {
            if (venta.pago && venta.pago.datosMercadoPago) {
              this.actualizarTiposSellosMercadoPago(venta.detalles);
              let ventas = this.state.ventas_mp;
              ventas.push(venta);
              this.setState({
                ventas_mp: ventas,
              });
            } else {
              let detalle = venta.detalles
                ? venta.detalles
                : venta.detalle_venta.detalle;
              this.actualizarTiposSellos(detalle);
              let ventas = this.state.ventas_efectivo;
              ventas.push(venta);
              this.setState({
                ventas_efectivo: ventas,
              });
            }
          }
        });

        //Una vez que tenemos todos los datos, mostramos la tabla.
        this.setState({
          ...this.state,
          idOrganismo,
          nombreOrganismo,
          fechaInicio,
          fechaFin,
          step: 1,
          loading: false,
        });
      });
  };

  generateReport = (fechaInicio, fechaFin) => {
    console.log('entre al report');
    this.setState({ loading: true });
    this.props.client
      .query({
        query: generateReport,
        variables: { fechaInicio, fechaFin },
      })
      .then(response => {
        console.log({ response });
        this.setState({
          fechaInicio: fechaInicio,
          fechaFin: fechaFin,
          loading: false,
          step: 1,
          reportUri: response.data.generateReport,
        });
        // const win = window.open(response.data.generateReport, '_blank');
        // win.onload = () => (win.location = response.data.generateReport);
      });
  };

  actualizarTiposSellos = detalles => {
    //Esta funcion, recorre los detalle de una venta
    // Y actualiza el estado interno de componente, dependiendo los sellos del detalle.
    try {
      _.map(detalles, detalle => {
        console.log('DETALLE: ', detalle);
        let nuevosTipo_sellos = this.state.tipo_sellos;
        let nuevoDetalle = {
          idTipo_Sello: detalle.tipo_sello._id,
          nombre: detalle.tipo_sello.nombre,
          valor: detalle.tipo_sello.valor,
          cantidad: detalle.cantidad,
        };
        nuevosTipo_sellos.push(nuevoDetalle);

        var output = _(nuevosTipo_sellos)
          .groupBy('idTipo_Sello')
          .map((objs, key) => ({
            key: key,
            idTipo_Sello: key,
            nombre: objs[0].nombre,
            valor: objs[0].valor,
            cantidad: _.sumBy(objs, 'cantidad'),
            subtotal: objs[0].valor * _.sumBy(objs, 'cantidad'),
          }))
          .value();

        this.setState({
          ...this.state,
          tipo_sellos: output,
        });
      });
    } catch (err) {
      Modal.error({
        title: 'Error en el calculo de los items de ventas',
        content:
          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
      });
      console.log(err);
    }
  };

  actualizarTiposSellosPosnet = detalles => {
    //Esta funcion, recorre los detalle de una venta
    // Y actualiza el estado interno de componente, dependiendo los sellos del detalle.

    try {
      _.map(detalles, detalle => {
        let nuevosTipo_sellos = this.state.detalle_posnet;
        let nuevoDetalle = {
          idTipo_Sello: detalle.tipo_sello._id,
          nombre: detalle.tipo_sello.nombre,
          valor: detalle.tipo_sello.valor,
          cantidad: detalle.cantidad,
        };
        nuevosTipo_sellos.push(nuevoDetalle);

        var output = _(nuevosTipo_sellos)
          .groupBy('idTipo_Sello')
          .map((objs, key) => ({
            key: key,
            idTipo_Sello: key,
            nombre: objs[0].nombre,
            valor: objs[0].valor,
            cantidad: _.sumBy(objs, 'cantidad'),
            subtotal: objs[0].valor * _.sumBy(objs, 'cantidad'),
          }))
          .value();

        this.setState({
          ...this.state,
          detalle_posnet: output,
        });
      });
    } catch (err) {
      Modal.error({
        title: 'Error en el calculo de los items de ventas',
        content:
          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
      });
      console.log(err);
    }
  };

  actualizarTiposSellosMercadoPago = detalles => {
    //Esta funcion, recorre los detalle de una venta
    // Y actualiza el estado interno de componente, dependiendo los sellos del detalle.

    try {
      _.map(detalles, detalle => {
        let nuevosTipo_sellos = this.state.detalle_mp;
        let nuevoDetalle = {
          idTipo_Sello: detalle.tipo_sello._id,
          nombre: detalle.tipo_sello.nombre,
          valor: detalle.tipo_sello.valor,
          cantidad: detalle.cantidad,
        };
        nuevosTipo_sellos.push(nuevoDetalle);

        var output = _(nuevosTipo_sellos)
          .groupBy('idTipo_Sello')
          .map((objs, key) => ({
            key: key,
            idTipo_Sello: key,
            nombre: objs[0].nombre,
            valor: objs[0].valor,
            cantidad: _.sumBy(objs, 'cantidad'),
            subtotal: objs[0].valor * _.sumBy(objs, 'cantidad'),
          }))
          .value();

        this.setState({
          ...this.state,
          detalle_mp: output,
        });
      });
    } catch (err) {
      Modal.error({
        title: 'Error en el calculo de los items de ventas de mercado pago',
        content:
          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
      });
      console.log(err);
    }
  };

  onCancelar = () => {
    this.setState({
      ...this.state,
      step: 0,
      reportUri: undefined,
    });
  };

  onDescargar = () => {
    let data = _.map(this.state.tipo_sellos, detalle => {
      return {
        modalidad: 'EFECTIVO',
        precio: detalle.valor,
        cantidad: detalle.cantidad,
        subtotal: detalle.subtotal,
      };
    });

    let dataPosnet = _.map(this.state.detalle_posnet, detalle => {
      return {
        modalidad: 'POSNET',
        precio: detalle.valor,
        cantidad: detalle.cantidad,
        subtotal: detalle.subtotal,
      };
    });

    let dataMercadoPago = _.map(this.state.detalle_mp, detalle => {
      return {
        modalidad: 'MERCADO PAGO',
        precio: detalle.valor,
        cantidad: detalle.cantidad,
        subtotal: detalle.subtotal,
      };
    });

    data = [...data, ...dataPosnet, ...dataMercadoPago];
    descargarCSV(
      ['TIPO PAGO', 'PRECIO', 'CANTIDAD', 'SUBTOTAL'],
      data,
      `ReporteVentasPorFecha-${moment(this.state.fechaInicio).format(
        'DD/MM/YYYY'
      )}-${moment(this.state.fechaFin).format('DD/MM/YYYY')}.csv`
    );
  };

  render() {
    const { data } = this.props;
    if (data.loading || this.state.loading) {
      return <Loading />;
    }

    // if (!data.getUsuario) {
    //   return null;
    // }

    const { Step } = Steps;
    let { step } = this.state;
    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');
    let montoTotal = _.sumBy(this.state.tipo_sellos, o => {
      return o.subtotal;
    });

    let montoTotalPosnet = _.sumBy(this.state.detalle_posnet, o => {
      return o.subtotal;
    });
    let montoTotalMP = _.sumBy(this.state.detalle_mp, o => {
      return o.subtotal;
    });

    let fInicio = moment(this.state.fechaInicio).format('DD/MM/YYYY');
    let fFin = moment(this.state.fechaFin).format('DD/MM/YYYY');

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Administracion General</Breadcrumb.Item>
          <Breadcrumb.Item>Reportes</Breadcrumb.Item>
          <Breadcrumb.Item>Ventas Por Fecha</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h1 className="tituloForm">Administración General</h1>
          <Steps className="stepsFormularios" current={step}>
            <Step title="Seleccionar Fechas" />
            <Step title="Visualizar Resultados" />
          </Steps>
          {step == 0 && (
            <FormRangoFechas
              buscar={this.buscar}
              buscarSQL={this.buscarSql}
              generateReport={this.generateReport}
            />
          )}
          {step == 1 && (
            <React.Fragment>
              <h2 style={{ textAlign: 'center', marginTop: 40 }}>
                Organismo: {this.state.nombreOrganismo}
              </h2>

              <h3 style={{ textAlign: 'center', marginTop: 20 }}>
                Reporte para el rango de fechas de: {fInicio} - {fFin}{' '}
              </h3>
              {this.state.reportUri !== undefined ? (
                <Row>
                  <Col span={8} offset={8}>
                    <a href={this.state.reportUri} target="_self">
                      DESCARGAR
                    </a>
                    {/* <h4>{this.state.reportUri}</h4> */}
                  </Col>
                </Row>
              ) : (
                <React.Fragment>
                  <Row>
                    <Col span={8} offset={8}>
                      <h5 style={{ textAlign: 'center', marginTop: 20 }}>
                        Fecha de generacion: {fGeneracion}
                      </h5>
                    </Col>
                    <Col span={6}>
                      <Button type="primary" onClick={() => this.onDescargar()}>
                        <Icons.DownloadOutlined />
                        Descargar Reporte
                      </Button>
                    </Col>
                  </Row>

                  <br />
                  <Col span={8} offset={8}>
                    <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                      {' '}
                      Ventas Efectivo:{' '}
                    </h3>
                    <TablaMostrarReporte
                      organismo={this.state.nombreOrganismo}
                      fechaInicio={this.state.fechaInicio}
                      fechaFin={this.state.fechaFin}
                      data={this.state.tipo_sellos}
                      onCancelar={this.onCancelar}
                    />
                    <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                      Monto Total:{' '}
                      {montoTotal.toLocaleString('es-AR', {
                        style: 'currency',
                        currency: 'ARS',
                      })}{' '}
                    </h3>
                  </Col>

                  <br />
                  <Col span={8} offset={8}>
                    <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                      {' '}
                      Ventas Posnet:{' '}
                    </h3>
                    <TablaMostrarReporte
                      organismo={this.state.nombreOrganismo}
                      fechaInicio={this.state.fechaInicio}
                      fechaFin={this.state.fechaFin}
                      data={this.state.detalle_posnet}
                      onCancelar={this.onCancelar}
                    />
                    <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                      Monto Total:{' '}
                      {montoTotalPosnet.toLocaleString('es-AR', {
                        style: 'currency',
                        currency: 'ARS',
                      })}{' '}
                    </h3>
                  </Col>

                  <br />
                  <Col span={8} offset={8}>
                    <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                      {' '}
                      Ventas Mercado Pago:{' '}
                    </h3>
                    <TablaMostrarReporte
                      organismo={this.state.nombreOrganismo}
                      fechaInicio={this.state.fechaInicio}
                      fechaFin={this.state.fechaFin}
                      data={this.state.detalle_mp}
                      onCancelar={this.onCancelar}
                    />
                    <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                      Monto Total:{' '}
                      {montoTotalMP.toLocaleString('es-AR', {
                        style: 'currency',
                        currency: 'ARS',
                      })}{' '}
                    </h3>
                  </Col>

                  <Row>
                    <Col span={8} offset={8} style={{ textAlign: 'center' }}>
                      <Button
                        type="primary"
                        // style={{ marginLeft: '33%' }}
                        onClick={() =>
                          imprimirReporte({
                            nombreOrganismo: this.state.nombreOrganismo,
                            fechaGeneracion: fGeneracion,
                            fechaInicio: moment(this.state.fechaInicio).format(
                              'DD/MM/YYYY'
                            ),
                            fechaFin: moment(this.state.fechaFin).format(
                              'DD/MM/YYYY'
                            ),
                            detalle: this.state.tipo_sellos,
                            detallePosnet: this.state.detalle_posnet,
                            detalle_mp: this.state.detalle_mp,
                            montoTotal: montoTotal,
                            montoTotalPosnet: montoTotalPosnet,
                            montoTotalMP: montoTotalMP,
                            ventas_efectivo: this.state.ventas_efectivo,
                            ventas_posnet: this.state.ventas_posnet,
                            ventas_mp: this.state.ventas_mp,
                          })
                        }
                      >
                        {' '}
                        Imprimir Datos{' '}
                      </Button>
                      <Button
                        style={{ marginLeft: 10 }}
                        type="danger"
                        onClick={() => this.onCancelar()}
                      >
                        {' '}
                        Atras{' '}
                      </Button>
                    </Col>
                  </Row>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </Layout>
      </div>
    );
  }
}

export default withApollo(ReportePorRango);
